window.dataLayer = window.dataLayer || [];
export default function event() {
  // console.log("event", arguments);
  window.dataLayer.push(...arguments);
}
window.gaEvent = event;
// app_ready c
// app_launch c
// camera_permissions
// motion_permissions
//  prescribe_information_clicked c
// additional_information_clicked
// experience_button_start c
//  experience_time_spent
//  experience_placed c
//  experience_closed
//  experience_complete c
// skip_to_drop_comparision_clicked c
// skip_to_blink_comparision_clicked c
//  visit_website_clicked c
